var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["legalperson.code"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "legalpersonCode"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseInput"] +
                        _vm.language["legalperson.code"],
                      disabled: _vm.formDisabled
                    },
                    model: {
                      value: _vm.model.legalpersonCode,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "legalpersonCode", $$v)
                      },
                      expression: "model.legalpersonCode"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["legalperson.name"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "legalpersonName"
                  }
                },
                [
                  _c("a-input", {
                    staticStyle: { width: "85%" },
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseInput"] +
                        _vm.language["legalperson.name"],
                      disabled: _vm.formDisabled
                    },
                    model: {
                      value: _vm.model.legalpersonName,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "legalpersonName", $$v)
                      },
                      expression: "model.legalpersonName"
                    }
                  }),
                  _c(
                    "a-button",
                    {
                      staticStyle: { left: "3%" },
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.languageModelOpen(
                            "EpBdPerson",
                            "legalpersonName",
                            _vm.nameLanguages
                          )
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.language["common.language"]))]
                  )
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["legalperson.legalpersonPerson"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "legalpersonPerson"
                  }
                },
                [
                  _c("a-input", {
                    staticStyle: { width: "85%" },
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseInput"] +
                        _vm.language["legalperson.legalpersonPerson"],
                      disabled: _vm.formDisabled
                    },
                    model: {
                      value: _vm.model.legalpersonPerson,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "legalpersonPerson", $$v)
                      },
                      expression: "model.legalpersonPerson"
                    }
                  }),
                  _c(
                    "a-button",
                    {
                      staticStyle: { left: "3%" },
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.languageModelOpen(
                            "EpBdPerson",
                            "legalpersonPerson",
                            _vm.legalpersonPersonLanguages
                          )
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.language["common.language"]))]
                  )
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["legalperson.address"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "address"
                  }
                },
                [
                  _c("a-input", {
                    staticStyle: { width: "85%" },
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseInput"] +
                        _vm.language["legalperson.address"],
                      disabled: _vm.formDisabled
                    },
                    model: {
                      value: _vm.model.address,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "address", $$v)
                      },
                      expression: "model.address"
                    }
                  }),
                  _c(
                    "a-button",
                    {
                      staticStyle: { left: "3%" },
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.languageModelOpen(
                            "EpBdPerson",
                            "address",
                            _vm.addressLanguages
                          )
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.language["common.language"]))]
                  )
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["legalperson.socialCreditCode"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "socialCreditCode"
                  }
                },
                [
                  _c("a-input", {
                    attrs: { disabled: _vm.formDisabled },
                    model: {
                      value: _vm.model.socialCreditCode,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "socialCreditCode", $$v)
                      },
                      expression: "model.socialCreditCode"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["legalperson.phone"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "phone"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseInput"] +
                        _vm.language["legalperson.phone"],
                      disabled: _vm.formDisabled
                    },
                    model: {
                      value: _vm.model.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "phone", $$v)
                      },
                      expression: "model.phone"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["legalperson.telephone"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "telephone"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseInput"] +
                        _vm.language["legalperson.telephone"],
                      disabled: _vm.formDisabled
                    },
                    model: {
                      value: _vm.model.telephone,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "telephone", $$v)
                      },
                      expression: "model.telephone"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.language["basedata.remark"],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "remark"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        _vm.language["common.pleaseInput"] +
                        _vm.language["basedata.remark"],
                      disabled: _vm.formDisabled
                    },
                    model: {
                      value: _vm.model.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "remark", $$v)
                      },
                      expression: "model.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("language-model", {
            ref: "languageModel",
            on: { ok: _vm.languageOk }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }